import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Button, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import BranchEmployees from "../../features/branches/branchEmployess";

const BranchDetail = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Branch Detail</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/manage-leaves")}>Branches</span> -
            Branch Detail
          </p>
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      {/* Tabs for Navigation */}
      <Tabs
        sx={{ mb: 2 }}
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
      >
        <Tab label="Branch Details" />
        <Tab label="Employees" />
      </Tabs>

      {/* Tab Content */}
      {activeTab === 0 ? (
        <div className="cards">
          <div className="profileInfo_list">
            <ul className="text_info gap_p">
              <li
                className="w_100"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <strong>Branch Image</strong>
                <span>
                  <figure style={{ height: 150, width: 150 }}>
                    <img
                      src="/static/images/picture.png"
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </figure>
                </span>
              </li>
              <li
                className="w_50"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <strong>Branch Name</strong>
                <span>Dubai</span>
              </li>

              <li
                className="w_50"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <strong>Branch Address</strong>
                <span>Po Box 17373 Jebel Ali Free Zone, Dubai</span>
              </li>

              <li className="w_50 vw_doc">
                <strong> Trade License</strong>
                <span>
                  <figure>
                    <img src="/static/images/pdf.png" alt="" />
                  </figure>
                </span>
              </li>
              <li className="w_50 vw_doc">
                <strong> Memorandum</strong>
                <span>
                  <figure>
                    <img src="/static/images/pdf.png" alt="" />
                  </figure>
                </span>
              </li>
              <li className="w_50 vw_doc">
                <strong>Emirates Id Partner 1</strong>
                <span>
                  <figure>
                    <img src="/static/images/pdf.png" alt="" />
                  </figure>
                </span>
              </li>
              <li className="w_50 vw_doc">
                <strong>Emirates Id Partner 2</strong>
                <span>
                  <figure>
                    <img src="/static/images/pdf.png" alt="" />
                  </figure>
                </span>
              </li>
              <li className="w_50 vw_doc">
                <strong>Ijari</strong>
                <span>
                  <figure>
                    <img src="/static/images/pdf.png" alt="" />
                  </figure>
                </span>
              </li>
              <li className="w_50" />
            </ul>
          </div>
        </div>
      ) : null}

      {/* Employees Tab Content */}
      {activeTab === 1 ? <BranchEmployees /> : null}
    </MainContainer>
  );
};

export default BranchDetail;
